// src/deviceTZ.ts
function deviceTZ() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
export {
  deviceTZ
};
//# sourceMappingURL=deviceTZ.mjs.map